import * as React from 'react';
import DateRange from 'src/components/common/DateRange';
import DateRangeModel from 'src/model/dateRange.model';
import * as moment from 'moment';
import {
  statusType,
  sortType,
  orderType,
  invoiceType,
  nardType,
  ordernumberType,
  poType
} from 'src/model/modules/invoices.model';
import {
  IFiltersInvoice,
  IPaginationInvoice
} from 'src/services/invoice/InvoiceService';
import SearchIcon from 'src/assets/searchIcon';
import CloseIcon from 'src/assets/close';
import DateRangeSelector from '../DatePicker/index';

import './PaymentHistoryFilters.scss';
import MultipleSelectStatus from '../Filter/AllStatus';
import MultipleSelect from '../Filter/AllInvoices';
import { SET_INVOICES_DATA } from 'src/store/modules/invoices/types';
import ItemLoader from 'src/components/Lists/components/ItemLoader';
import { getInvoicesIsPendingSel } from 'src/store/modules/invoices';
import PaymentHistorySearchFilter from '../Filter/PaymentHistorySearchFilter';
import AllStatus from '../Filter/AllStatus';
import InvoiceService from 'src/services/invoice';
import Button from 'src/components/common/Button';
import i18n from 'src/translation/i18n';
export const SEARCH_FILTER_MAPPING = {
  'Invoice Number': `${i18n.t('invoices.invoiceNo')}`,
  'Narda Number': `${i18n.t('invoices.nardaNo')}`,
  'Order Number': `${i18n.t('invoices.orderNo')}`,
  'Purchase Order Number': `${i18n.t('invoices.purchaseOrderNo')}`
};
class PaymentHistoryFilters extends React.Component<
  any,
  IPaymentHistoryFiltersState
> {
  constructor(props: IPaymentHistoryFiltersProps) {
    super(props);
    const start = moment(
      new Date(new Date().setFullYear(new Date().getFullYear() - 1))
    );
    const end = moment(new Date());
    const datRange: any = { start, end };
    this.state = {
      calendarIsOpen: false,
      searchValue: '',
      isReset: false,
      invoiceSearch: null,
      date: { start, end },
      status: null,
      searchKeyVal: 'Invoice Number',
      open: false,
      dateRange: {
        startDate: new Date(
          new Date().setFullYear(new Date().getFullYear() - 1)
        ),
        endDate: new Date()
      },
      disableSearch: true,
      displayDatePicker: true,
      isResetSearch: false
    };
    this.getFilteredInvoices(datRange, null, null);
  }

  private getFilteredInvoices = (
    dates: DateRangeModel | null = this.props.datesFilter,
    status: statusType = this.props.statusFilter,
    orderStatus: orderType = this.props.orderFilter,
    invoiceNumber: invoiceType = this.props.invoiceFilter,
    nardaNumber: nardType = this.props.nardFilter,
    orderNumber: ordernumberType = this.props.orderNumberFilter,
    orderReference: poType = this.props.poNumberFilter
  ) => {
    const filters: IFiltersInvoice = {
      dateRange: dates,
      status,
      orderStatus,
      invoiceNumber,
      nardaNumber,
      orderNumber,
      orderReference,
      sort: { ...this.props.sortFilter }
    };
    this.props.setfiltervalues(filters);
    // const pagination: IPaginationInvoice = {
    //   page: 0
    // };

    // this.props.getInvoices(filters, pagination);
  };

  private setFilters = (searchKey: any, searchVal: any) => {
    const { checkReset } = this.props;
    this.setState({
      isReset: false,
      isResetSearch: false
    });
    if (searchKey) {
      this.setState({
        disableSearch: false,
        searchKeyVal: searchKey,
        searchValue: ''
      });
    } else {
      this.getFilteredInvoices(
        this.state.date,
        this.state.status,
        this.state.invoiceSearch
      );
      this.setState({
        disableSearch: true,
        searchValue: '',
        searchKeyVal: 'Invoice Number'
      });
    }
    checkReset(true);
  };

  private handleChange = (event: React.FormEvent<HTMLInputElement>) => {
    // this.setFilters(this.state.searchKeyVal, event.currentTarget.value);
    this.setState({ searchValue: event.currentTarget.value });
    const { checkReset } = this.props;
    checkReset(true);
  };

  private handleClearSearch = () => {
    this.resetInvoiceSearch();
    this.getFilteredInvoices(
      this.state.date,
      this.state.status,
      this.state.invoiceSearch
    );
  };
  private handlesearch = () => {
    let invoiceNumber = null;
    let nardaNumber = null;
    let orderNumber = null;
    let orderReference = null;
    const searchKeyValue = this.state.searchKeyVal;
    const finalSearchValue = this.state.searchValue.trim();
    this.setState({ searchValue: finalSearchValue });
    if (searchKeyValue === 'Invoice Number') {
      invoiceNumber = finalSearchValue;
    } else if (searchKeyValue === 'Narda Number') {
      nardaNumber = finalSearchValue;
    } else if (searchKeyValue === 'Order Number') {
      orderNumber = finalSearchValue;
    } else {
      orderReference = finalSearchValue;
    }
    if (
      (invoiceNumber || nardaNumber || orderNumber || orderReference) &&
      searchKeyValue
    ) {
      this.getFilteredInvoices(
        this.state.date,
        this.state.status,
        this.state.invoiceSearch,
        invoiceNumber ? invoiceNumber : null,
        nardaNumber ? nardaNumber : null,
        orderNumber ? orderNumber : null,
        orderReference ? orderReference : null
      );
    }
  };

  private handleKeyPress = (event: any) => {
    if (event.keyCode === 13) {
      this.handlesearch();
    }
  };

  public clearFilters = (filters: null) => {
    const { checkReset } = this.props;
    const start = moment(
      new Date(new Date().setFullYear(new Date().getFullYear() - 1))
    );
    const end = moment(new Date());
    const datRange: any = { start, end };
    checkReset(true);
    this.getFilteredInvoices(null, null, null);
    this.setState({
      isReset: true,
      searchValue: '',
      date: null,
      invoiceSearch: null,
      status: null,
      searchKeyVal: 'Invoice Number',
      open: false,
      dateRange: {},
      disableSearch: true,
      displayDatePicker: false
    });
    setTimeout(() => {
      this.setState({ displayDatePicker: true });
    }, 50);
  };

  public resetInvoiceSearch = () => {
    this.setState({
      searchValue: '',
      searchKeyVal: 'Invoice Number',
      disableSearch: true,
      isResetSearch: true
    });
  };

  public filterByInvoice = (invoice: any) => {
    this.setState({ invoiceSearch: invoice });
    this.getFilteredInvoices(this.state.date, this.state.status, invoice);
    this.setState({ isReset: false });
    this.resetInvoiceSearch();
    const { checkReset, setFirstActive } = this.props;
    checkReset(true);
  };
  public filterByStatus = (statusValue: any) => {
    this.setState({ status: statusValue });
    this.getFilteredInvoices(
      this.state.date,
      statusValue,
      this.state.invoiceSearch
    );
    this.setState({ isReset: false });
    this.resetInvoiceSearch();
    const { checkReset } = this.props;
    checkReset(true);
  };

  public filterByDate = (dateRange: any) => {
    this.setState({ date: dateRange });
    this.getFilteredInvoices(
      dateRange,
      this.state.status,
      this.state.invoiceSearch
    );
    this.setState({ isReset: false });
  };

  public toggle = () => this.setState({ open: !this.state.open });

  public setCurrentDateRange = (range: any) => {
    this.setState({ dateRange: range });
  };

  public handleDatePickerApply = (range: any) => {
    if (range['startDate'] && range['endDate']) {
      this.setState({ dateRange: range });
      const start = moment(range['startDate']);
      const end = moment(range['endDate']);
      this.filterByDate({ start, end });
      this.setState({ open: false });
      this.resetInvoiceSearch();
      const { checkReset } = this.props;
      checkReset(true);
    }
  };

  public componentDidUpdate = () => {
    const { cardActive, SetCardActiveStatus } = this.props;
    if (cardActive) {
      this.setState({
        isReset: true,
        searchValue: '',
        date: null,
        invoiceSearch: null,
        status: null,
        searchKeyVal: 'Invoice Number',
        open: false,
        dateRange: {}
      });
      SetCardActiveStatus(false);
    }
  };

  public getPlaceHolderText = () => {
    if (this.state.searchKeyVal) {
      const selected = SEARCH_FILTER_MAPPING[this.state.searchKeyVal]
        ? SEARCH_FILTER_MAPPING[this.state.searchKeyVal]
        : i18n.t('invoices.purchaseOrderNo').toString();
      const placeholder = `${i18n.t('invoices.searchBy')} ${selected}`;
      return placeholder;
    }
    if (window.innerWidth < 1024) {
      return null;
    }
    return `${i18n.t('invoices.searchBy')}`;
  };

  public render() {
    const {
      searchKeyVal,
      open,
      isReset,
      dateRange,
      searchValue,
      isResetSearch
    } = this.state;
    return (
      <div className="searchClear-container">
        <div className="d-flex filtersSection">
          {/* <MultipleSelect
            filter={this.filterByInvoice}
            isReset={isReset}
            status={this.state.status}
          />
          <MultipleSelectStatus
            filter={this.filterByStatus}
            isReset={isReset}
            invoiceSearch={this.state.invoiceSearch}
          /> */}
          {this.state.displayDatePicker && (
            <React.Fragment>
              <div className="lable-text">
                {i18n.t('invoices.paymentDate')}{' '}
              </div>
              <div className="rp-tracking-filterbar">
                <div className="rp-tracking-filterbar--filters">
                  <div className="filters-components">
                    <div className="date-range-container">
                      <DateRangeSelector
                        isReset={isReset}
                        open={open}
                        dateRange={dateRange}
                        toggle={this.toggle}
                        setCurrentDateRange={this.setCurrentDateRange}
                        handleDatePickerApply={this.handleDatePickerApply}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </React.Fragment>
          )}

          <div className="wrapper">
            {/* <div className="wrapper-container"> */}
            <PaymentHistorySearchFilter
              setFilters={this.setFilters}
              isReset={isReset}
              isResetSearch={isResetSearch}
            />
            <div className="search-container">
              <input
                type="text"
                placeholder={this.getPlaceHolderText()}
                style={{
                  borderTopRightRadius: '5px',
                  borderBottomRightRadius: '5px'
                }}
                onChange={this.handleChange}
                onKeyDown={this.handleKeyPress}
                value={searchValue}
                // className={this.state.disableSearch ? 'disable-search' : ''}
              />
              {searchValue && (
                <img
                  className="close-icon"
                  alt="clear"
                  src={CloseIcon}
                  onClick={this.handleClearSearch}
                />
              )}
              <img
                className="search-icon"
                alt="search"
                src={SearchIcon}
                onClick={this.handlesearch}
              />
            </div>
          </div>
          <button className="clear-filters w-auto" onClick={this.clearFilters}>
            {i18n.t('common.clearAllFiters')}
          </button>
        </div>
      </div>
    );
  }
}

export default PaymentHistoryFilters;
interface IPaymentHistoryFiltersProps {
  t: any;
  datesFilter: DateRangeModel;
  statusFilter: statusType;
  orderFilter: orderType;
  invoiceFilter: invoiceType;
  nardFilter: nardType;
  orderNumberFilter: ordernumberType;
  poNumberFilter: poType;
  sortFilter: { type: sortType; order: 'asc' | 'desc' };
  getInvoices(filters: IFiltersInvoice, pagination: IPaginationInvoice): void;
  clearAlert: () => void;
  setfiltervalues: any;
}
interface IPaymentHistoryFiltersState {
  calendarIsOpen: boolean;
  searchValue: any;
  searchKeyVal: any;
  dateRange: object;
  open: boolean;
  isReset: boolean;
  invoiceSearch: any;
  date: any;
  status: any;
  disableSearch: boolean;
  displayDatePicker: boolean;
  isResetSearch: boolean;
}
